export default "__VITE_ASSET__BaCC8Daw__"